module.exports = __webpack_public_path__ + "img/shop-banner.2035afff.jpg";